import React, { useState } from "react";
import axios from "axios";
import { ConsultaSolicitudPorId } from "../Services/Rest";
import { Link } from "react-router-dom";
function ConsultarCaso() {
  const [list, setList] = useState([]);
  const [caso, setCaso] = useState([]);

  const BusacarCaso = () => {
    axios
      .get(ConsultaSolicitudPorId + caso)
      .then((response) => {
        setList(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handlecountry = (event) => {
    const casoId = event.target.value;
    setCaso(casoId);
  };
  const fecha = new Date();
  return (
    <div>
      <div className="container">
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                  Consultar Caso
                </h6>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <form className="user">
                    <div className="form-group row">
                      <div className="col-sm-6 ">
                        <input
                          type="number"
                          className="form-control form-control-user"
                          placeholder="Buscar El Numero Del Caso"
                          onChange={(e) => handlecountry(e)}
                        />
                      </div>
                      <hr />
                      <div className="col-sm-6 ">
                        <button
                          className="btn btn-primary btn-user btn-block"
                          onClick={() => BusacarCaso()}
                        >
                          Buscar
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <center>
        <h2>
          <a>
            <Link to={"/"}>Volver</Link>
          </a>
        </h2>
      </center>
      <div className="test">
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    Información de la solicitud
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <form className="user">
                      <div className="form-group row">
                        <div className="col-sm-12">
                          <input
                            type="text"
                            className="form-control form-control-user"
                            placeholder={
                              "Correo del Gestor: " +
                              list.map((item) => {
                                return item.regional;
                              })
                            }
                            disabled
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-12">
                          <textarea
                            type="text"
                            className="form-control form-control-user"
                            placeholder={
                              "Descripción: " +
                              list.map((item) => {
                                return item.descripcion;
                              })
                            }
                            disabled
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-6 mb-3 mb-sm-0">
                          <input
                            type="text"
                            className="form-control form-control-user"
                            placeholder={
                              "Estado:  " +
                              list.map((item) => {
                                return item.estado;
                              })
                            }
                            disabled
                          />
                        </div>
                        <div className="col-sm-6 ">
                          <input
                            type="text"
                            className="form-control form-control-user"
                            placeholder={fecha.toLocaleDateString(
                              "en-US",
                              list.map((item) => {
                                return item.fechaCreacion;
                              })
                            )}
                            disabled
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConsultarCaso;
